import { useConfigStore } from "@/stores/config"
import type { QuestionsOptions } from "@/types/s3"

export async function getQuestions(options: QuestionsOptions) {
  const { urls } = useConfigStore()

  const url = `${urls.assets}/questions/${options.test}.json`

  const response = await fetch(url, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  })
  const data = await response.json()

  return {
    questions: data,
  }
}
